import AuthController from '@/controllers/AuthController';
import { Forms } from '@/enums/Forms';
import NavigationHelper from '@/util/NavigationHelper';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ValidationRules from '@/util/ValidationRules';
import { Ref, ref } from 'vue';
import PageHelper from '@/util/PageHelper';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField.vue';
import { VForm } from 'vuetify/components';

export default {
  name: 'SignUpForm',
  components: {
    PolteqButton,
    PolteqTextField
  },
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const rules = ValidationRules.getRules();
    const signUpForm = ref() as Ref<VForm>;
    const signUp = async (
      firstname: string,
      lastname: string,
      company: string,
      emailaddress: string,
      phonenumber: string,
      newpassword: string
    ) => {
      await signUpForm.value.validate();
      if (signUpForm.value.isValid) {
        const response = await AuthController.signUp(
          firstname,
          lastname,
          company,
          emailaddress,
          phonenumber,
          newpassword
        );
        PageHelper.setNotificationMessage(response);
        await NavigationHelper.openForm(router, Forms.SIGN_IN);
      }
    };
    return {
      router,
      i18n,
      rules,
      signUpForm,
      signUp
    };
  },
  data() {
    return {
      company: '',
      confirm: '',
      emailaddress: '',
      phonenumber: '',
      firstname: '',
      lastname: '',
      newpassword: ''
    };
  }
};
